export default "assets/images/map-d1fa16a4.jpg";